/* Guía de talles v3 — Sofia Sarkany (theme de prueba)
 * Lee los datos que imprime snippets/guia-talles-v3.liquid (<script data-gt-json>) y arma:
 * talles, medidas de la prenda (talle base + progresión), medidas del cuerpo, recomendador y CTA.
 */
(function () {
  'use strict';

  /* Umbrales de holgura (cm) = contorno de la prenda − medida del cuerpo.
     PENDIENTE validar con Diseño. Se usan solo para describir cómo queda, no para elegir el talle. */
  var FIT_LEVELS = [
    { max: 0, label: 'Justo', tone: 'tight' },
    { max: 4, label: 'Ajustado', tone: 'snug' },
    { max: 8, label: 'Regular', tone: 'regular' },
    { max: Infinity, label: 'Holgado', tone: 'loose' }
  ];
  var STORAGE_KEY = 'sofi_gt_medidas_v1';

  var TYPE_DIAGRAM = {
    jean: 'pantalon', pantalon: 'pantalon', capri: 'pantalon',
    short: 'short', bermuda: 'short',
    pollera: 'pollera',
    vestido: 'vestido', mono: 'mono', entero: 'mono', bikini: 'bikini',
    remera: 'superior', top: 'superior', musculosa: 'superior', camisa: 'superior', buzo: 'superior',
    campera: 'superior', sweater: 'superior', cardigan: 'superior', chomba: 'superior', saco: 'superior', tapado: 'superior'
  };

  function norm(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim();
  }
  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function fmt(n) {
    if (n === null || n === undefined || isNaN(n)) return '–';
    return String(Math.round(n * 10) / 10).replace('.', ',');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function push(action, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var ev = { event: 'size_guide_interaction', sg_action: action, sg_version: 'v3' };
      for (var k in extra) ev[k] = extra[k];
      window.dataLayer.push(ev);
    } catch (e) {}
  }

  /* "Talle 26 Largo: 105,5cm Cintura: 38cm ..." → { base: '26', items: [{label, key, value}] } */
  function parseGarment(text) {
    var out = { base: null, items: [] };
    if (!text) return out;
    var m = text.match(/talle\s*:?\s*([A-Za-z0-9]+)/i);
    if (m) out.base = m[1];
    var re = /([^:\n\d]+?)\s*:\s*(\d+(?:[.,]\d+)?)\s*(?:cm)?/gi, r;
    while ((r = re.exec(text))) {
      var label = r[1].replace(/^\s*(cm\b)?\s*/i, '').replace(/^talle\s*:?\s*[A-Za-z0-9]+\s*/i, '').replace(/^[\s|·,;-]+/, '').trim();
      if (!label || /^talle$/i.test(label)) continue;
      out.items.push({ label: cap(label), key: norm(label), value: num(r[2]) });
    }
    return out;
  }
  /* "DENIM: Largo: -/+ 0,5cm Cintura: -/+ 1cm" → { 'largo': 0.5, 'cintura': 1 }
     Tolera: los dos puntos faltantes ("Largo -/+ 2cm") y "NO PROGRESIONA" (= 0, igual en todos los talles). */
  function parseProgression(text) {
    var out = {}, count = 0;
    if (!text) return null;
    var re = /([^:\n\d+\-\/±]+?)\s*(?::\s*)?(?:(?:-\s*\/\s*\+|\+\s*\/\s*-|±|mas\s*\/?\s*menos|\+\s*-)\s*(\d+(?:[.,]\d+)?)\s*(?:cm)?|:\s*(no\s+progresiona))/gi, r;
    while ((r = re.exec(text))) {
      var key = norm(String(r[1]).replace(/^\s*cm\b/i, ''));
      if (!key) continue;
      out[key] = r[3] ? 0 : num(r[2]); count++;
    }
    return count ? out : null;
  }
  /* Busca la progresión de una medida aunque el nombre varíe un poco ("Largo total de bretel" = "Largo de bretel"). */
  function looseKey(k) { return String(k || '').replace(/\b(total|de|del|la|el|los|las)\b/g, ' ').replace(/\s+/g, ' ').trim(); }
  function progFor(prog, key) {
    if (!prog) return undefined;
    if (prog[key] !== undefined) return prog[key];
    var lk = looseKey(key);
    for (var k in prog) if (looseKey(k) === lk) return prog[k];
    return undefined;
  }

  function fitFor(h) {
    for (var i = 0; i < FIT_LEVELS.length; i++) if (h < FIT_LEVELS[i].max) return FIT_LEVELS[i];
    return FIT_LEVELS[FIT_LEVELS.length - 1];
  }

  /* Dibujos esquemáticos. Cada medida se dibuja solo si existe en los datos. */
  function diagramSVG(kind, letterOf) {
    var L = function (k) { return letterOf[k] || ''; };
    var dash = 'stroke="#2f5bd3" stroke-width="2" stroke-dasharray="5 4"';
    var t = function (x, y, s) { return s ? '<text x="' + x + '" y="' + y + '" text-anchor="middle" font-size="15" font-weight="700" fill="currentColor">' + s + '</text>' : ''; };
    var ln = function (k, d) { return letterOf[k] ? '<path d="' + d + '" ' + dash + '/>' : ''; };
    var body = '';
    if (kind === 'vestido' || kind === 'mono') {
      var sleeve = !!L('largo de manga');
      var strapKey = L('largo total de bretel') ? 'largo total de bretel' : 'largo de bretel';
      var upper = sleeve ? 'M76 25 Q100 44 124 25 L151 41 L184 134 L165 142 L140 80 L137 121' :
        'M65 51 L65 20 Q73 14 81 20 L81 52 Q100 65 119 52 L119 20 Q127 14 135 20 L135 51 Q132 85 137 121';
      var lower = kind === 'mono' ? ' L150 281 L108 281 L100 187 L92 281 L50 281 L63 121' : ' L164 281 L36 281 L63 121';
      var close = sleeve ? ' L60 80 L35 142 L16 134 L49 41 Z' : ' Q68 85 65 51 Z';
      body = '<path d="' + upper + lower + close + '" fill="#f3f3f3" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
        ln('largo', 'M100 ' + (sleeve ? '39' : '62') + ' L100 281') + t(112, 228, L('largo')) +
        ln('ancho de busto', 'M65 92 L135 92') + t(100, 84, L('ancho de busto'));
      if (sleeve) body += ln('largo de manga', 'M157 39 L191 134') + t(202, 83, L('largo de manga'));
      if (L(strapKey)) body += '<path d="M177 170 L177 255" fill="none" stroke="currentColor" stroke-width="2"/>' +
        ln(strapKey, 'M189 170 L189 255') + t(202, 216, L(strapKey));
      return '<svg viewBox="0 -10 215 310" width="150" height="217">' + body + '</svg>';
    }
    if (kind === 'bikini') {
      var underKey = L('contorno total bajo busto (con breteles)') ? 'contorno total bajo busto (con breteles)' : 'contorno total bajo busto';
      body = '<path d="M24 107 Q40 77 57 47 Q74 77 89 107 Z M107 107 Q123 77 140 47 Q157 77 173 107 Z" fill="#f3f3f3" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
        '<path d="M57 47 L43 25 M140 47 L154 25 M12 112 L186 112 M89 107 Q98 117 107 107" fill="none" stroke="currentColor" stroke-width="2"/>' +
        ln('ancho de taza', 'M24 125 L89 125') + t(56, 142, L('ancho de taza')) +
        ln('altura de taza', 'M57 50 L57 107') + t(69, 84, L('altura de taza')) +
        '<path d="M39 187 Q100 204 161 187 L151 207 Q123 229 112 279 L88 279 Q77 229 49 207 Z" fill="#f3f3f3" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
        ln('ancho colaless', 'M39 173 L161 173') + t(100, 165, L('ancho colaless')) +
        ln('tiro', 'M100 198 L100 279') + t(112, 245, L('tiro')) +
        ln('lados regulables', 'M178 187 L178 207') + t(194, 202, L('lados regulables'));
      if (L(underKey)) body += '<path d="M24 312 L176 312" fill="none" stroke="currentColor" stroke-width="2"/>' +
        ln(underKey, 'M24 324 L176 324') + t(100, 344, L(underKey));
      if (L('breteles')) body += '<path d="M51 368 L149 368" fill="none" stroke="currentColor" stroke-width="2"/>' +
        ln('breteles', 'M51 380 L149 380') + t(100, 400, L('breteles'));
      return '<svg viewBox="0 0 215 412" width="150" height="287">' + body + '</svg>';
    }
    if (kind === 'pantalon' || kind === 'short') {
      var bottom = kind === 'short' ? 150 : 288;
      var crotch = kind === 'short' ? 118 : 128;
      body = '<path d="M50 22 L150 22 L162 84 L' + (kind === 'short' ? 170 : 182) + ' ' + bottom + ' L108 ' + bottom + ' L100 ' + crotch + ' L92 ' + bottom + ' L' + (kind === 'short' ? 30 : 18) + ' ' + bottom + ' L38 84 Z" fill="#f3f3f3" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
        '<path d="M51 34 L149 34 M100 34 L100 100" stroke="currentColor" stroke-width="1.2"/>' +
        ln('cintura', 'M50 12 L150 12') + t(100, 8, L('cintura')) +
        ln('cadera', 'M38 84 L162 84') + t(26, 80, L('cadera')) +
        ln('tiro', 'M116 22 L116 ' + crotch) + t(128, 112, L('tiro')) +
        ln('largo', 'M196 22 L196 ' + bottom) + t(205, (22 + bottom) / 2, L('largo'));
      return '<svg viewBox="0 -10 215 310" width="150" height="217">' + body + '</svg>';
    }
    if (kind === 'pollera') {
      body = '<path d="M60 30 L140 30 L172 250 L28 250 Z" fill="#f3f3f3" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
        '<path d="M61 42 L139 42" stroke="currentColor" stroke-width="1.2"/>' +
        ln('cintura', 'M60 20 L140 20') + t(100, 14, L('cintura')) +
        ln('cadera', 'M50 100 L150 100') + t(36, 104, L('cadera')) +
        ln('largo', 'M188 30 L188 250') + t(200, 145, L('largo'));
      return '<svg viewBox="0 -10 215 310" width="150" height="217">' + body + '</svg>';
    }
    if (kind === 'superior') {
      body = '<path d="M70 20 Q100 40 130 20 L176 44 L198 104 L170 114 L156 82 L156 270 L44 270 L44 82 L30 114 L2 104 L24 44 Z" fill="#f3f3f3" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
        ln('ancho de busto', 'M44 110 L156 110') + t(100, 128, L('ancho de busto')) +
        ln('largo', 'M100 34 L100 270') + t(112, 200, L('largo')) +
        ln('largo de manga', 'M130 26 L190 98') + t(200, 62, L('largo de manga'));
      return '<svg viewBox="0 -10 215 310" width="150" height="217">' + body + '</svg>';
    }
    return '';
  }

  /* ---------- CSV de temporada (archivo que sube Ecommerce) ---------- */
  function decodeText(buf) {
    try { return new TextDecoder('utf-8', { fatal: true }).decode(buf); }
    catch (e) { return new TextDecoder('windows-1252').decode(buf); }
  }
  function parseCSV(text) {
    text = String(text || '').replace(/^﻿/, '');
    var first = text.split(/\r?\n/)[0] || '';
    var counts = { ',': 0, ';': 0, '\t': 0 }, q = false;
    for (var i = 0; i < first.length; i++) { var ch = first[i]; if (ch === '"') q = !q; else if (!q && counts[ch] !== undefined) counts[ch]++; }
    var del = counts[';'] > counts[','] ? ';' : (counts['\t'] > counts[','] ? '\t' : ',');
    var rows = [], row = [], cell = '', inQ = false;
    for (var k = 0; k < text.length; k++) {
      var c = text[k];
      if (inQ) {
        if (c === '"') { if (text[k + 1] === '"') { cell += '"'; k++; } else inQ = false; }
        else cell += c;
      } else if (c === '"') inQ = true;
      else if (c === del) { row.push(cell); cell = ''; }
      else if (c === '\n' || c === '\r') { if (c === '\r' && text[k + 1] === '\n') k++; row.push(cell); rows.push(row); row = []; cell = ''; }
      else cell += c;
    }
    if (cell !== '' || row.length) { row.push(cell); rows.push(row); }
    return rows.filter(function (r) { return r.some(function (x) { return String(x).trim() !== ''; }); });
  }
  /* Encabezados flexibles: acepta los nombres del Excel de Diseño y variantes. */
  function mapHeader(h) {
    var n = norm(h);
    if (/^sku/.test(n)) return 'sku';
    if (/progres/.test(n)) return 'prog';
    if (/^medida/.test(n)) return 'medida';
    if (/^tipo/.test(n)) return 'tipo';
    if (/^fit/.test(n)) return 'fit';
    if (/nota/.test(n)) return 'nota';
    if (/ajuste/.test(n)) return 'ajuste';
    if (/^nombre|^producto/.test(n)) return 'nombre';
    return null;
  }
  function tableToRecords(rows) {
    if (!rows.length) return [];
    var map = rows[0].map(mapHeader);
    return rows.slice(1).map(function (r) {
      var o = {};
      map.forEach(function (k, i) { if (k && o[k] === undefined) o[k] = String(r[i] == null ? '' : r[i]).trim(); });
      return o;
    }).filter(function (o) { return o.sku; });
  }
  function splitFit(s) {
    return String(s || '').split(/\s*[|\/;\n]\s*/).map(function (x) { return x.trim(); }).filter(Boolean);
  }
  /* El SKU del Excel es el del modelo+color (ej. JP7VSTRAP%AZ); el de la variante agrega el talle (JP7VSTRAP%AZ26). */
  function findRecord(records, variants, sizeIdx) {
    var best = null, bestScore = -1;
    records.forEach(function (rec) {
      var base = rec.sku.toLowerCase().replace(/\s+/g, '');
      variants.forEach(function (v) {
        var vs = String(v.sku || '').toLowerCase().replace(/\s+/g, '');
        if (!vs || vs.indexOf(base) !== 0) return;
        var rest = vs.slice(base.length), size = String(v.options[sizeIdx] || '').toLowerCase().replace(/\s+/g, '');
        var score = rest === size ? 3 : (rest === '' ? 2 : (/^[a-z0-9]{1,3}$/.test(rest) ? 1 : -1));
        if (score < 0) return;
        score = score * 1000 + base.length;
        if (score > bestScore) { bestScore = score; best = rec; }
      });
    });
    return best;
  }
  var csvCache = {};
  function loadCSV(url) {
    if (csvCache[url]) return csvCache[url];
    var key = 'gt_csv_' + url;
    try { var c = sessionStorage.getItem(key); if (c) return (csvCache[url] = Promise.resolve(c)); } catch (e) {}
    csvCache[url] = fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status); return r.arrayBuffer();
    }).then(function (buf) {
      var t = decodeText(buf);
      try { sessionStorage.setItem(key, t); } catch (e) {}
      return t;
    });
    return csvCache[url];
  }

  function SizeGuide(root) {
    var jsonEl = root.querySelector('[data-gt-json]');
    if (!jsonEl) return;
    var d;
    try { d = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    this.root = root; this.d = d;
    this.sizes = d.sizes || [];
    this.garment = { base: null, items: [] };
    this.prog = null;
    this.record = null;
    this.status = null;
    this.body = null;
    if (d.body) {
      var b = typeof d.body === 'string' ? JSON.parse(d.body) : d.body;
      this.body = {};
      for (var s in b) {
        this.body[String(s).toLowerCase()] = {};
        for (var k in b[s]) this.body[String(s).toLowerCase()][norm(k)] = { label: cap(k), value: num(b[s][k]) };
      }
    }
    this.baseIdx = -1;
    this.letters = {};
    this.selected = null;
    this.tab = 'prenda';
    this.init();
  }

  SizeGuide.prototype.garmentFor = function (size) {
    var idx = this.sizes.map(function (s) { return String(s).toLowerCase(); }).indexOf(String(size).toLowerCase());
    var self = this;
    return this.garment.items.map(function (it) {
      var v = null;
      if (idx === self.baseIdx && idx > -1) v = it.value;
      else if (self.baseIdx > -1 && idx > -1 && progFor(self.prog, it.key) !== undefined) v = it.value + (idx - self.baseIdx) * progFor(self.prog, it.key);
      else if (self.baseIdx === -1 && String(size).toLowerCase() === String(self.garment.base || '').toLowerCase()) v = it.value;
      return { label: it.label, key: it.key, value: v, letter: self.letters[it.key] };
    });
  };
  SizeGuide.prototype.hint = function (key) {
    var kind = TYPE_DIAGRAM[norm(this.d.tipo)] || '';
    if (/contorno/.test(key)) return 'Contorno';
    if (/^(cintura|cadera|ancho de busto)$/.test(key)) return 'En plano, de lado a lado';
    if (key === 'tiro' && (kind === 'pantalon' || kind === 'short')) return 'De la cintura a la entrepierna';
    if (key === 'largo' && (kind === 'pantalon' || kind === 'short' || kind === 'pollera')) return 'De la cintura al ruedo';
    if (key === 'largo' && kind === 'superior') return 'Del hombro al ruedo';
    if (key === 'largo de manga') return 'Del hombro al puño';
    return '';
  };
  SizeGuide.prototype.hasProgression = function () { return !!(this.prog && this.baseIdx > -1); };
  SizeGuide.prototype.contour = function (key, value) {
    if (value === null) return null;
    if (/contorno/.test(key)) return value;
    return this.d.flatMeasures ? value * 2 : value;
  };
  /* Pares cuerpo ↔ prenda que describen el calce. En prendas con tiro (jean, pantalón, short)
     la pretina no va en la cintura natural, así que se compara la cadera. */
  SizeGuide.prototype.zones = function () {
    var g = {}, hasTiro = false;
    this.garment.items.forEach(function (it) { g[it.key] = true; if (it.key === 'tiro') hasTiro = true; });
    var z = [];
    if (g['cadera']) z.push({ body: 'cadera', garment: 'cadera', label: 'Cadera' });
    if (g['ancho de busto']) z.push({ body: 'pecho', garment: 'ancho de busto', label: 'Busto' });
    if (g['cintura'] && !hasTiro) z.push({ body: 'cintura', garment: 'cintura', label: 'Cintura' });
    return z;
  };
  SizeGuide.prototype.variantFor = function (size) {
    var d = this.d, form = document.getElementById(d.productFormId);
    var idInput = form && form.querySelector('[name="id"]');
    var currentId = idInput ? parseInt(idInput.value, 10) : null;
    var current = d.variants.filter(function (v) { return v.id === currentId; })[0] || d.variants[0];
    var target = (current ? current.options.slice() : []);
    target[d.sizeOptionIndex] = size;
    return d.variants.filter(function (v) {
      return v.options.every(function (o, i) { return String(o).toLowerCase() === String(target[i]).toLowerCase(); });
    })[0] || null;
  };
  SizeGuide.prototype.sizeAvailable = function (size) {
    var v = this.variantFor(size);
    return v ? v.available : false;
  };

  SizeGuide.prototype.init = function () {
    var self = this, root = this.root;
    this.sizeBtns = Array.prototype.slice.call(root.querySelectorAll('.gt-size'));
    this.sizeBtns.forEach(function (btn) {
      if (!self.sizeAvailable(btn.dataset.talle)) btn.classList.add('is-soldout');
      btn.addEventListener('click', function () { self.select(btn.dataset.talle, true); push('size', { sg_value: btn.dataset.talle }); });
    });
    root.querySelectorAll('[data-gt-tab]').forEach(function (t) {
      t.addEventListener('click', function () { self.setTab(t.dataset.gtTab); push('tab', { sg_value: t.dataset.gtTab }); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var other = root.querySelector('[data-gt-tab]:not([data-gt-tab="' + t.dataset.gtTab + '"])');
          if (other) { other.focus(); other.click(); }
        }
      });
    });
    var allT = root.querySelector('[data-gt-all-toggle]');
    if (allT) {
      allT.addEventListener('click', function () {
        var box = root.querySelector('[data-gt-all]');
        var open = allT.getAttribute('aria-expanded') !== 'true';
        allT.setAttribute('aria-expanded', open); box.hidden = !open;
        allT.textContent = open ? 'OCULTAR TABLA' : 'VER TODOS LOS TALLES';
        if (open) push('table', {});
      });
    }
    this.initReco();
    var cta = root.querySelector('[data-gt-cta]');
    if (cta) cta.addEventListener('click', function () { self.addToCart(cta); });

    // Al abrir: tomar el talle elegido en la PDP
    new MutationObserver(function () {
      if (root.hasAttribute('open')) self.onOpen();
    }).observe(root, { attributes: true, attributeFilter: ['open'] });

    this.applyLayout();
    this.render();
    this.loadData();
  };

  /* Busca la fila del producto en los CSV de las temporadas activas. */
  SizeGuide.prototype.loadData = function () {
    var self = this, srcs = (this.d.sources || []).filter(Boolean);
    this.status = { sources: srcs, matched: null, error: null, done: false };
    if (!srcs.length) { this.status.done = true; this.applyLayout(); this.debug(); return; }
    Promise.all(srcs.map(function (u) {
      return loadCSV(u).then(function (t) { return { url: u, records: tableToRecords(parseCSV(t)) }; })
        .catch(function (e) { return { url: u, records: [], error: String(e) }; });
    })).then(function (lists) {
      for (var i = 0; i < lists.length; i++) {
        if (lists[i].error) self.status.error = lists[i].error;
        var rec = findRecord(lists[i].records, self.d.variants, self.d.sizeOptionIndex);
        if (rec) { self.status.matched = { url: lists[i].url, sku: rec.sku, rows: lists[i].records.length }; self.applyRecord(rec); break; }
      }
      self.status.done = true;
      if (!self.status.matched) { self.applyLayout(); self.render(); }
      push('data', { sg_has_garment: !!self.status.matched, product_handle: self.d.productHandle });
      self.debug();
    });
  };
  SizeGuide.prototype.applyRecord = function (rec) {
    var self = this, root = this.root;
    this.record = rec;
    this.garment = /\d/.test(rec.medida || '') ? parseGarment(rec.medida) : { base: null, items: [] };
    this.prog = parseProgression(rec.prog);
    if (!this.d.tipo && rec.tipo) this.d.tipo = rec.tipo;
    var aj = parseInt(String(rec.ajuste || '').replace(',', '.'), 10);
    this.d.ajuste = isNaN(aj) ? 0 : Math.max(-2, Math.min(2, aj));
    this.baseIdx = -1;
    if (this.garment.base) for (var i = 0; i < this.sizes.length; i++) if (String(this.sizes[i]).toLowerCase() === String(this.garment.base).toLowerCase()) this.baseIdx = i;
    this.letters = {};
    var abc = 'ABCDEFGHIJ';
    this.garment.items.forEach(function (it, i) { self.letters[it.key] = abc[i]; });
    // Fit + nota de calce
    var fitBox = root.querySelector('[data-gt-fit]'), chips = splitFit(rec.fit);
    if (fitBox && (chips.length || rec.nota)) {
      fitBox.innerHTML = (chips.length ? '<ul class="gt-fit-chips" aria-label="Fit de la prenda">' + chips.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul>' : '') +
        (rec.nota ? '<p class="gt-fit-note">' + esc(rec.nota) + '</p>' : '');
      fitBox.hidden = false;
    }
    // Dibujo
    var dg = root.querySelector('[data-gt-diagram]');
    if (dg) {
      var svg = diagramSVG(TYPE_DIAGRAM[norm(this.d.tipo)] || '', this.letters);
      dg.innerHTML = svg; dg.hidden = !svg;
      var grid = root.querySelector('.gt-measure-grid'); if (grid) grid.classList.toggle('no-diagram', !svg);
    }
    // Solo talle base
    var only = root.querySelector('[data-gt-only-base]');
    if (only) { only.hidden = this.hasProgression() || !this.garment.base; if (this.garment.base) only.querySelector('[data-gt-base]').textContent = this.garment.base; }
    var allT = root.querySelector('[data-gt-all-toggle]');
    if (allT) allT.hidden = !this.hasProgression();
    // Largo en el talle de la modelo (solo si ese talle está medido)
    var mm = (this.d.modelText || '').match(/usa\s+(?:el\s+)?talle\s+([A-Za-z0-9]+)/i);
    var extra = root.querySelector('[data-gt-model-extra]');
    if (mm && extra) {
      var g = this.garmentFor(mm[1]).filter(function (x) { return x.key === 'largo' && x.value !== null; })[0];
      if (g) { extra.innerHTML = 'Largo de la prenda en su talle: <strong>' + fmt(g.value) + ' cm</strong>'; extra.hidden = false; }
    }
    if (!this.userTab && this.hasGarment()) this.tab = 'prenda';
    this.applyLayout();
    this.render();
  };
  SizeGuide.prototype.hasGarment = function () { return this.garment.items.length > 0; };
  /* Qué se ve según los datos que hay: tabs, panel prenda, panel cuerpo o aviso vacío. */
  SizeGuide.prototype.applyLayout = function () {
    var self = this, root = this.root, hasG = this.hasGarment(), hasB = !!this.body;
    var tabs = root.querySelector('[data-gt-tabs]'), pp = root.querySelector('[data-gt-panel="prenda"]'), pc = root.querySelector('[data-gt-panel="cuerpo"]');
    var empty = root.querySelector('[data-gt-empty]');
    if (!hasG && hasB) this.tab = 'cuerpo';
    if (hasG && !hasB) this.tab = 'prenda';
    if (tabs) tabs.hidden = !(hasG && hasB);
    if (pp) pp.hidden = !hasG || this.tab !== 'prenda';
    if (pc) pc.hidden = !hasB || this.tab !== 'cuerpo';
    if (empty) empty.hidden = hasG || hasB || !(this.status && this.status.done);
    root.querySelectorAll('[data-gt-tab]').forEach(function (t) {
      var on = t.dataset.gtTab === self.tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
    });
  };
  /* Panel interno para el equipo: agregar ?gt_debug=1 a la URL del producto. */
  SizeGuide.prototype.debug = function () {
    if (!/[?&]gt_debug=1/.test(location.search)) return;
    var box = this.root.querySelector('[data-gt-debug]');
    if (!box) return;
    var st = this.status || {}, m = st.matched, self = this;
    var fname = function (u) { return esc(String(u).split('/').pop().split('?')[0]); };
    var lines = ['<strong>Diagnóstico interno (solo con ?gt_debug=1)</strong>'];
    lines.push('Archivos activos: ' + (st.sources && st.sources.length ? st.sources.map(fname).join(', ') : '<b>ninguno</b> → revisar Contenido › Metaobjetos › Guía de talles · Temporadas'));
    lines.push('SKU de las variantes: ' + esc(this.d.variants.map(function (v) { return v.sku; }).slice(0, 3).join(', ')) + (this.d.variants.length > 3 ? '…' : ''));
    if (m) {
      lines.push('Fila encontrada: <b>' + esc(m.sku) + '</b> en ' + fname(m.url) + ' (' + m.rows + ' filas)');
      lines.push('Talle base: ' + esc(this.garment.base || '—') + (this.baseIdx < 0 && this.garment.base ? ' <b>⚠ no está entre los talles del producto (' + esc(this.sizes.join(', ')) + ')</b>' : ''));
      lines.push('Medidas leídas: ' + (this.garment.items.length ? this.garment.items.map(function (it) { return esc(it.label) + ' ' + fmt(it.value); }).join(' · ') : '<b>ninguna</b> → la fila no tiene medidas' + (this.record && this.record.medida ? ' ("' + esc(this.record.medida) + '")' : '') + '. La web muestra solo la tabla del cuerpo.'));
      lines.push('Progresión: ' + (this.prog ? Object.keys(this.prog).map(function (k) { return esc(k) + ' ±' + fmt(self.prog[k]); }).join(' · ') : 'sin progresión → solo talle base'));
      var miss = this.prog ? this.garment.items.filter(function (it) { return progFor(self.prog, it.key) === undefined; }).map(function (it) { return it.label; }) : [];
      if (miss.length) lines.push('⚠ Sin progresión para: ' + esc(miss.join(', ')) + ' (solo se muestran en el talle base)');
      lines.push('Ajuste del recomendador: ' + this.d.ajuste + ' · Tipo (dibujo): ' + esc(this.d.tipo || '—'));
    } else {
      lines.push('<b>Este producto no está en los archivos.</b> ' + (st.error ? 'Error al leer: ' + esc(st.error) : 'Revisar que el SKU del Excel sea el del modelo+color, sin el talle.'));
    }
    lines.push('Tabla de cuerpo: ' + (this.body ? 'sí (metaobjeto talles_por_coleccion)' : 'no hay para las colecciones de este producto'));
    box.innerHTML = lines.map(function (l) { return '<p>' + l + '</p>'; }).join('');
    box.hidden = false;
  };

  SizeGuide.prototype.pdpSize = function () {
    var d = this.d, name = d.sizeOptionName;
    var r = document.querySelector('input[type="radio"][form="' + d.productFormId + '"][name="' + name + '"]:checked');
    if (r) return r.value;
    var sel = document.querySelector('select[form="' + d.productFormId + '"][name="options[' + name + ']"]');
    return sel ? sel.value : null;
  };
  SizeGuide.prototype.onOpen = function () {
    var s = this.pdpSize();
    if (s && this.sizes.indexOf(s) > -1) this.select(s, false);
    else if (!this.selected) {
      var first = this.sizes.filter(this.sizeAvailable.bind(this))[0] || this.sizes[0];
      if (first) this.select(first, false);
    }
    push('open', { product_handle: this.d.productHandle });
  };
  SizeGuide.prototype.syncPdp = function (size) {
    var d = this.d, name = d.sizeOptionName;
    var r = document.querySelector('input[type="radio"][form="' + d.productFormId + '"][name="' + name + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(size) : size) + '"]');
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); return; }
    var sel = document.querySelector('select[form="' + d.productFormId + '"][name="options[' + name + ']"]');
    if (sel && sel.value !== size) { sel.value = size; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  };
  SizeGuide.prototype.select = function (size, fromUser) {
    this.selected = size;
    if (fromUser) this.syncPdp(size);
    this.render();
  };
  SizeGuide.prototype.setTab = function (tab) {
    this.tab = tab; this.userTab = true;
    this.applyLayout();
  };

  SizeGuide.prototype.render = function () {
    var self = this, root = this.root, size = this.selected;
    this.sizeBtns.forEach(function (b) {
      var on = size !== null && b.dataset.talle === size;
      b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-gt-size-label]').forEach(function (el) { el.textContent = size || '—'; });
    // Sin progresión: la prenda siempre muestra el talle base (el único medido)
    var gSize = this.hasProgression() ? size : (this.garment.base || size);
    var pLabel = root.querySelector('[data-gt-panel="prenda"] [data-gt-size-label]');
    if (pLabel && gSize) pLabel.textContent = gSize;

    var pr = root.querySelector('[data-gt-prenda-rows]');
    if (pr) {
      var rows = gSize ? this.garmentFor(gSize) : this.garment.items.map(function (it) { return { label: it.label, key: it.key, value: null, letter: self.letters[it.key] }; });
      pr.innerHTML = rows.map(function (r) {
        var hint = self.hint(r.key);
        return '<div class="gt-row"><span class="gt-key">' + r.letter + '</span><span class="gt-row-label">' + esc(r.label) +
          (hint ? '<small>' + hint + '</small>' : '') + '</span><span class="gt-row-val">' + fmt(r.value) + '</span></div>';
      }).join('');
    }
    var cr = root.querySelector('[data-gt-cuerpo-rows]');
    if (cr) {
      var b = size && this.body ? this.body[String(size).toLowerCase()] : null;
      cr.innerHTML = b ? Object.keys(b).map(function (k, i) {
        return '<div class="gt-row"><span class="gt-key">' + 'ABCDEF'[i] + '</span><span class="gt-row-label">' + esc(k === 'pecho' ? 'Busto' : b[k].label) + '<small>Contorno</small></span><span class="gt-row-val">' + fmt(b[k].value) + '</span></div>';
      }).join('') : '<p class="gt-empty">No hay medidas de cuerpo para este talle.</p>';
    }
    var all = root.querySelector('[data-gt-all]');
    if (all && this.hasProgression()) {
      var head = '<tr><th scope="col">TALLE</th>' + this.garment.items.map(function (it) { return '<th scope="col">' + self.letters[it.key] + ' ' + esc(it.label.toUpperCase()) + '</th>'; }).join('') + '</tr>';
      var body = this.sizes.map(function (s) {
        var g = self.garmentFor(s);
        return '<tr class="' + (s === size ? 'is-active' : '') + '"><th scope="row">' + esc(s) + '</th>' + g.map(function (x) { return '<td>' + fmt(x.value) + '</td>'; }).join('') + '</tr>';
      }).join('');
      all.innerHTML = '<table class="gt-table"><thead>' + head + '</thead><tbody>' + body + '</tbody></table>';
    }
    var cta = root.querySelector('[data-gt-cta]');
    if (cta && !cta.classList.contains('is-loading')) {
      if (!size) { cta.disabled = true; cta.textContent = 'ELEGÍ TU TALLE'; }
      else if (!this.sizeAvailable(size)) { cta.disabled = true; cta.textContent = 'SIN STOCK EN TALLE ' + size; }
      else { cta.disabled = false; cta.textContent = 'AGREGAR TALLE ' + size + ' AL CARRITO'; }
    }
  };

  /* ---------- Recomendador ---------- */
  SizeGuide.prototype.initReco = function () {
    var self = this, root = this.root, reco = root.querySelector('[data-gt-reco]');
    if (!reco || !this.body) return;
    var keys = {};
    Object.keys(this.body).forEach(function (s) { Object.keys(self.body[s]).forEach(function (k) { keys[k] = self.body[s][k].label; }); });
    // solo medidas que tengan los talles del producto
    this.recoKeys = Object.keys(keys).filter(function (k) { return k !== 'largo'; });
    if (!this.recoKeys.length || !this.sizes.some(function (s) { return self.body[String(s).toLowerCase()]; })) { reco.remove(); return; }
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) {}
    var inputs = reco.querySelector('[data-gt-reco-inputs]');
    inputs.innerHTML = this.recoKeys.map(function (k) {
      var id = 'gt-in-' + self.d.blockId + '-' + k.replace(/\W/g, '');
      var label = k === 'pecho' ? 'Busto' : keys[k];
      return '<label class="gt-input" for="' + id + '"><span>' + esc(label) + ' (cm)</span><input id="' + id + '" name="' + esc(k) + '" type="number" inputmode="decimal" min="40" max="160" step="0.5" placeholder="Ej: ' + self.example(k) + '" value="' + (saved[k] ? esc(saved[k]) : '') + '"></label>';
    }).join('');
    var toggle = reco.querySelector('[data-gt-reco-toggle]'), body = reco.querySelector('[data-gt-reco-body]');
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', open); body.hidden = !open;
      if (open) { var f = body.querySelector('input'); if (f) setTimeout(function () { f.focus(); }, 50); push('reco_open', {}); }
    });
    reco.querySelector('[data-gt-reco-form]').addEventListener('submit', function (e) { e.preventDefault(); self.recommend(); });
  };
  SizeGuide.prototype.example = function (k) {
    var mid = this.sizes[Math.floor(this.sizes.length / 2)];
    var b = mid && this.body[String(mid).toLowerCase()];
    return b && b[k] ? fmt(b[k].value) : '70';
  };
  SizeGuide.prototype.recommend = function () {
    var self = this, reco = this.root.querySelector('[data-gt-reco]');
    var err = reco.querySelector('[data-gt-reco-error]'), out = reco.querySelector('[data-gt-reco-result]');
    var u = {}, filled = 0, bad = false;
    reco.querySelectorAll('[data-gt-reco-inputs] input').forEach(function (inp) {
      if (inp.value === '') return;
      var v = num(inp.value);
      if (isNaN(v) || v < 40 || v > 160) bad = true; else { u[inp.name] = v; filled++; }
    });
    err.hidden = true;
    if (bad || !filled) {
      err.textContent = bad ? 'Revisá las medidas: tienen que estar en centímetros (entre 40 y 160).' : 'Ingresá al menos una medida para recomendarte un talle.';
      err.hidden = false; out.hidden = true; return;
    }
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(u)); } catch (e) {}
    var pref = parseInt((reco.querySelector('input[type="radio"]:checked') || {}).value || '0', 10);
    var list = this.sizes.filter(function (s) { return self.body[String(s).toLowerCase()]; });
    var baseIdx = -1;
    for (var i = 0; i < list.length; i++) {
      var b = this.body[String(list[i]).toLowerCase()], ok = true;
      for (var k in u) if (b[k] && u[k] > b[k].value) ok = false;
      if (ok) { baseIdx = i; break; }
    }
    var notes = [], above = baseIdx === -1;
    if (above) baseIdx = list.length - 1;
    var tableSize = list[baseIdx];
    notes.push(above ? 'Tus medidas superan nuestra tabla: el talle más grande es el <strong>' + esc(tableSize) + '</strong>.' :
      'Con tus medidas, en nuestra tabla corresponde el talle <strong>' + esc(tableSize) + '</strong>.');
    var aj = parseInt(this.d.ajuste || 0, 10) || 0;
    if (aj) notes.push(aj < 0 ? 'Esta prenda calza grande: sugerimos ' + (-aj) + ' talle' + (aj < -1 ? 's' : '') + ' menos.' : 'Esta prenda calza chica: sugerimos ' + aj + ' talle' + (aj > 1 ? 's' : '') + ' más.');
    if (pref) notes.push(pref < 0 ? 'Como la preferís ajustada, bajamos un talle.' : 'Como la preferís holgada, subimos un talle.');
    var idx = baseIdx + aj + pref, clamped = false;
    if (idx < 0) { idx = 0; clamped = true; }
    if (idx > list.length - 1) { idx = list.length - 1; clamped = true; }
    if (clamped && (aj || pref)) notes.push('Es el talle ' + (idx === 0 ? 'más chico' : 'más grande') + ' disponible en esta prenda.');
    var rec = list[idx];
    var zones = this.zones();
    var range = [idx - 1, idx, idx + 1].filter(function (j) { return j >= 0 && j < list.length; }).map(function (j) {
      var s = list[j], g = self.garmentFor(s), fitTxt = '';
      zones.forEach(function (z) {
        if (u[z.body] === undefined) return;
        var gv = g.filter(function (x) { return x.key === z.garment; })[0];
        if (!gv || gv.value === null) return;
        var h = self.contour(z.garment, gv.value) - u[z.body], f = fitFor(h);
        fitTxt = fitTxt || ('<span class="gt-fit-tag gt-fit-' + f.tone + '">' + f.label + '</span><small>' + z.label + ' ' + (h >= 0 ? '+' : '') + fmt(h) + ' cm</small>');
      });
      var avail = self.sizeAvailable(s);
      return '<button type="button" class="gt-range-item' + (j === idx ? ' is-rec' : '') + (avail ? '' : ' is-soldout') + '" data-size="' + esc(s) + '">' +
        '<span class="gt-range-size">' + esc(s) + '</span>' + (j === idx ? '<span class="gt-range-badge">RECOMENDADO</span>' : '') +
        (fitTxt || '') + (avail ? '' : '<small>Sin stock</small>') + '</button>';
    }).join('');
    out.innerHTML = '<p class="gt-reco-title">Tu talle recomendado: <strong>' + esc(rec) + '</strong></p>' +
      '<ul class="gt-reco-notes">' + notes.map(function (n) { return '<li>' + n + '</li>'; }).join('') + '</ul>' +
      (range ? '<div class="gt-range" role="group" aria-label="Talles cercanos">' + range + '</div>' : '') +
      (zones.length && this.garment.items.length ? '<p class="gt-reco-fine">La holgura compara el contorno de la prenda con tu medida. Más centímetros, más suelta.</p>' : '') +
      '<button type="button" class="gt-link" data-gt-reco-edit>CAMBIAR MIS MEDIDAS</button>';
    out.hidden = false;
    reco.querySelector('[data-gt-reco-form]').hidden = true;
    out.querySelectorAll('[data-size]').forEach(function (b) { b.addEventListener('click', function () { self.select(b.dataset.size, true); push('reco_pick', { sg_value: b.dataset.size }); }); });
    out.querySelector('[data-gt-reco-edit]').addEventListener('click', function () { out.hidden = true; reco.querySelector('[data-gt-reco-form]').hidden = false; });
    this.select(rec, true);
    push('reco', { sg_value: rec, sg_table_size: tableSize, sg_pref: pref, sg_adjust: aj });
  };

  /* ---------- Agregar al carrito ---------- */
  SizeGuide.prototype.addToCart = function (btn) {
    var self = this, v = this.variantFor(this.selected);
    if (!v || !v.available) return;
    btn.classList.add('is-loading'); btn.disabled = true; btn.textContent = 'AGREGANDO…';
    var fd = new FormData();
    fd.append('id', v.id); fd.append('quantity', 1);
    fd.append('sections', 'cart-drawer,cart-bubble'); fd.append('sections_url', window.location.pathname);
    fetch((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.status) throw new Error(data.description || 'Error');
      push('atc', { sg_value: self.selected, variant_id: v.id });
      if (data.sections) {
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && data.sections['cart-drawer']) {
          var inner = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html').querySelector('.cart-drawer-inner');
          var cur = drawer.querySelector('.cart-drawer-inner');
          if (inner && cur) cur.innerHTML = inner.innerHTML;
        }
        if (data.sections['cart-bubble'] && typeof window.updateCartBubbleSection === 'function') window.updateCartBubbleSection(data.sections['cart-bubble']);
      }
      if (self.root.hide) self.root.hide();
      var dr = document.getElementById('Cart-Drawer');
      if (dr) { document.body.classList.add('open-cc'); dr.classList.add('active'); }
      if (typeof window.dispatchCustomEvent === 'function') window.dispatchCustomEvent('cart:item-added', { product: data.items ? data.items[0] : data });
    }).catch(function (e) {
      console.error(e); btn.textContent = 'NO PUDIMOS AGREGARLO, PROBÁ DE NUEVO';
    }).then(function () {
      setTimeout(function () { btn.classList.remove('is-loading'); self.render(); }, 1500);
    });
  };

  function boot() {
    document.querySelectorAll('[data-gt-root]').forEach(function (el) {
      if (el.__gt) return; el.__gt = new SizeGuide(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.SofiSizeGuide = { boot: boot, parseGarment: parseGarment, parseProgression: parseProgression, progFor: progFor, parseCSV: parseCSV, tableToRecords: tableToRecords, findRecord: findRecord, splitFit: splitFit };
})();
